import axiosInstance from "../utils/axiosConfig";

export const blogService = {
  getAllBlogs: async () => {
    try {
      const response = await axiosInstance.get("/blogs");
      console.log("Blogs fetched:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching blogs:", {
        message: error.message,
        response: error.response,
        request: error.request,
      });

      // More detailed error handling
      if (error.response) {
        throw new Error(
          error.response.data.message ||
          `Server error: ${error.response.status}`
        );
      } else if (error.request) {
        throw new Error("No response received from server");
      } else {
        throw new Error("Error setting up the request");
      }
    }
  },

  getBlogById: async (id) => {
    try {
      const response = await axiosInstance.get(`/blogs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching blog by ID:", error);
      throw error; 
    }
  },
};

export default blogService;

//correct with 99
